export class AudioCache {
  #cache = new Map<string, HTMLAudioElement>()

  get(url: string): HTMLAudioElement {
    if (!this.#cache.has(url)) {
      this.#cache.set(url, new Audio(url))
    }
    return this.#cache.get(url)!
  }
}
